export const decideInitialTab = (userRoles, access_id) => {
	let choice = "Whistles";
	if(access_id)
		return "Whistle"
	if (userRoles) {
		const savedChoice = localStorage.getItem("dashboardTab")
		const isAdmin = userRoles.find((role) => role === 'company_administrator')
		if (savedChoice) {
			if(savedChoice === "Whistle"){
				choice = "Whistles"
			}else if (["LinkGenerator", "Users", "CompanySettings"].includes(savedChoice)) {
				if (isAdmin !== undefined) {
					choice = savedChoice
				}
			} else {
				choice = savedChoice
			}
		}
	}
	return choice
}
